import * as H from "history";
import {QueryParams} from "../shared/enums/queryParams";

export class Navigation {
  static navigateWithSelectedVillageId = (
    history: H.History,
    pathname: string,
    objectId: string | undefined = undefined
  ) => {
    const params = new URLSearchParams(history.location.search);
    const villageId = params.get(QueryParams.VillageId);

    let pathString = pathname;
    if (objectId) {
      pathString = pathString.replace(":id", objectId);
    }

    history.push({
      pathname: pathString,
      search: villageId ? `${QueryParams.VillageId}=${villageId}` : ""
    });
  };

  static navigateWithParams = (
    history: H.History,
    pathname: string,
    key: string,
    value: string,
    keysToClear?: string[]
  ) => {
    const params = new URLSearchParams(history.location.search);
    keysToClear?.forEach((key) => params.delete(key));
    params.delete(key);
    params.append(key, value);
    history.push({
      pathname,
      search: params.toString()
    });
  };

  static go = (history: H.History, pathname: string) => {
    history.push({
      pathname,
      search: history.location.search
    });
  };

  static getCurrentSearchParams = (history: H.History) =>
    new URLSearchParams(history.location.search);

  static getQueryParamByKey = (history: H.History, queryParam: QueryParams) => {
    const params = this.getCurrentSearchParams(history);
    return decodeURI(params.get(queryParam) || "");
  };
}
